import {FiLoader} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {ToggleButton} from "@/components/toggleButton/ToggleButton.tsx";
import {ANALYZER_TAB_ITEMS} from "@/pages/analyzer/Analyzer.constants.ts";
import {AnalyzerPhase, AnalyzerResultsHeaderProps, AnalyzerTab} from "@/pages/analyzer/Analyzer.types.ts";
import {hasCheckSelectionEvent, isProposingChecks} from "@/pages/analyzer/Analyzer.utils.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerResultsHeader.module.scss";

export const AnalyzerResultsHeader = ({activeTab, setActiveTab}: AnalyzerResultsHeaderProps) => {
  const {phase, analyzedDomain, resultsEvents} = useAnalyzerContext();
  const isGenerating = phase === AnalyzerPhase.STREAMING && !hasCheckSelectionEvent(resultsEvents);

  return (
    <div className={styles.header}>
      {isGenerating ? (
        <div className={styles.status}>
          <Icon icon={FiLoader} size="chip" className="pulseSpin" removeDivDimensions />
          <div className={styles.title}>
            {isProposingChecks(resultsEvents) ? "Proposing Checks..." : `Analyzing ${analyzedDomain}`}
          </div>
        </div>
      ) : (
        <div className={styles.titles}>
          <div className={styles.title}>Proposed Checks</div>
          <div className={styles.subtitle}>Review, refine, and create in your account</div>
        </div>
      )}
      <ToggleButton
        variant="segmented"
        items={ANALYZER_TAB_ITEMS}
        selectedId={activeTab}
        onChange={(tab) => setActiveTab(tab as AnalyzerTab)}
        disabled={isGenerating}
      />
    </div>
  );
};
